export default function changePriceDropLabel(label) {
  const labelElements = label.split(" ")
  let firstElement = labelElements[0]
  if (labelElements[0] === "a" || labelElements[0] === "an") {
    firstElement = "1"
  }
  return [[firstElement, labelElements[1][0]].join(""), labelElements[2]].join(" ")
}
